import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useDeviceSubtypesQuery } from 'app/stores/dictionary/raw/deviceSubtypes';
import { DeviceSubtypeCache, DeviceSubtypes } from '@kentik/ui-shared/dictionary/types';
import { useCallback } from 'react';

export const useDeviceSubtypes = (): UseQueryResult<DeviceSubtypeCache, Error> => {
  const baseQuery = useDeviceSubtypesQuery();
  const select = useCallback((data: DeviceSubtypes) => baseQuery.select(data).cachedTypes, [baseQuery]);
  return useQuery({
    ...baseQuery,
    select
  });
};
